import React from 'react';
import BackspaceIconImage from '../common/assets/backspace-squarekeyboard.svg';
import EnterIconImage from '../common/assets/enter.svg';
import SpaceIconImage from '../common/assets/space.svg';

export const EnterIcon = () => <EnterIconImage />;

export const BackspaceIcon = () => <BackspaceIconImage />;

export const SpaceIcon = () => <SpaceIconImage />;

export const SvgIcon = ({ Icon }: { Icon: () => React.JSX.Element }) => (
  <Icon />
);
